/**
 * @file The ReassignFormComponent is used to create a reassign request.
 * The form is activated with an action button and displayed in the overlay.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { NotificationsService } from '../notifications.service';
import { AlertsService } from '../../core/alerts.service';
import { OverlayService } from '../../core/overlay.service';
import { OverlayProvider } from '../../ui/overlay-provider';
import { RequestTypes } from '../request-types';
import { RequestStatus } from '../request-status';
import { BackendSettingsService } from '../../backend-settings.service';
import { AbstractBase } from '../../core/helpers/abstract-base';
import { TranslateService } from '@ngx-translate/core';
/**
 * The ReassignFormComponent is used to create a reassign request.
 * The form is activated with an action button and displayed in the overlay.
 * @export
 * @class ReassignFormComponent
 * @implements {OnInit}
 */
var ReassignFormComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ReassignFormComponent, _super);
    /**
     * Creates an instance of ReassignFormComponent.
     * @param {NotificationsService} notificationsService To communicate with the backend.
     * @param {AlertsService} alertsService  To show feedback messages to the user.
     * @param {OverlayService} overlayService The service that manage the overlay of the application.
     * @param {OverlayProvider} overlayProvider To provide the needed create parameters.
     */
    function ReassignFormComponent(notificationsService, alertsService, overlayService, overlayProvider, backendSettingsService, translateService) {
        var _this = _super.call(this) || this;
        _this.notificationsService = notificationsService;
        _this.alertsService = alertsService;
        _this.overlayService = overlayService;
        _this.backendSettingsService = backendSettingsService;
        _this.translateService = translateService;
        _this.subjectTask = overlayProvider.entity;
        if (!_this.subjectTask) {
            throw Error('Reassign task missing in ReassignFormComponent.');
        }
        if (_this.subjectTask.entityType.shortName === 'PlanItem') {
            _this.subjectTask = _this.subjectTask['Item'];
        }
        _this.formConfiguration = overlayProvider.configuration;
        var data = _this.formConfiguration.data;
        if (data) {
            var resourceField = data.fields.find(function (f) { return f.name === 'Resource'; });
            if (resourceField) {
                var format = resourceField.format;
                if (format) {
                    if (format.dataSource === 'ResourcesForWork') {
                        format.parameters = {
                            work: _this.entityOid
                        };
                    }
                }
            }
        }
        return _this;
    }
    Object.defineProperty(ReassignFormComponent.prototype, "requestId", {
        /**
         * Gets the Id of the current request.
         * @readonly
         * @type {number}
         */
        get: function () {
            if (!this.request) {
                return -1;
            }
            // Breeze.js find het niet leuk als je Id defined.
            // Maar ik heb hem nodig in template en dat find AOT weer niet leuk :(
            return this.request['Id'];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReassignFormComponent.prototype, "entityOid", {
        get: function () {
            return this.subjectTask['Oid'];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Lifecycle hook that is called after data-bound properties are initialized.
     * The reassign request is created and its properties are initialized.
     */
    ReassignFormComponent.prototype.ngOnInit = function () {
        this.request = this.notificationsService.getEntityType('Request').createEntity();
        if (this.subjectTask.entityType.shortName === 'Assignment') {
            this.request.Type = RequestTypes.ReassignAssignment;
        }
        else if (this.subjectTask.entityType.shortName === 'Attendant') {
            this.request.Type = RequestTypes.ReassignAttendant;
        }
        else {
            this.alertsService.createAlert('danger', 'Unknown subject type: ' + this.subjectTask.entityType.shortName);
        }
        this.request.Status = RequestStatus.Request;
        this.request.Title = this.translateService.instant('APP.NOTIFICATIONS.TYPE_REASSIGN') + " " + this.subjectTask['Name'];
        this.request.SubjectOid = this.subjectTask['Oid'];
        this.request.SenderOid = this.subjectTask['Resource_Oid'];
        this.notificationsService.addEntity(this.request);
    };
    /**
     * Returns a value indicating whether the request is ready to be saved.
     */
    ReassignFormComponent.prototype.canSave = function () {
        return this.request && this.request.ReceiverOid;
    };
    /**
     * Cancels the request and closes the overlay.
     */
    ReassignFormComponent.prototype.cancelItem = function () {
        this.request.entityAspect.rejectChanges();
        this.overlayService.closeOverlay();
    };
    /**
     * Saves the new created reassign request when valid.
     * @param {any} event The click event that triggered the method.
     * @returns void
     */
    ReassignFormComponent.prototype.saveItem = function (event) {
        var _this = this;
        // These are extra checks, because the send button ought to be disabled already.
        if (!this.request.ReceiverOid) {
            this.alertsService.createAlert('warning', 'APP.NOTIFICATIONS.PICK_RECEIVER');
            return;
        }
        if (!this.subjectTask) {
            this.alertsService.createAlert('warning', 'APP.NOTIFICATIONS.EXCHANGE_PICK_TASK');
            return;
        }
        if (!this.backendSettingsService.isOnTime(this.subjectTask)) {
            this.alertsService.createAlert('warning', 'APP.NOTIFICATIONS.TOO_LATE');
            return;
        }
        if (event) {
            event.target.classList.add('sym-working');
        }
        this.notificationsService.symptomManagementIssue1319();
        this.notificationsService.saveChanges(function (error) {
            // Remove sym-working to show that action is finished.
            if (event) {
                event.target.classList.remove('sym-working');
            }
            // Give correct alert based on whether an error is given or not.
            if (error) {
                _this.alertsService.createAlert('warning', 'APP.NOTIFICATIONS.REQUEST_UNSUCCESSFULLY_SENT');
            }
            else {
                _this.alertsService.createAlert('success', 'APP.NOTIFICATIONS.REQUEST_SUCCESSFULLY_SENT');
                _this.overlayService.closeOverlay();
            }
        });
    };
    return ReassignFormComponent;
}(AbstractBase));
export { ReassignFormComponent };
